import { Pipe, PipeTransform } from '@angular/core';

const statuses: Record<string, string> = {
  in_progress: 'In Progress',
  pending: 'Pending',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

@Pipe({
  name: 'tourLoadStatus',
})
export class TourLoadStatusPipe implements PipeTransform {
  public transform(value: string): unknown {
    return statuses[value] ?? value;
  }
}
